import { i18n } from "services/i18nService";
import {
  isOneOrMoreEmailAddresses,
  isSafeUrl,
} from "services/utility/validation";

import { initialErrorState } from "views/common";

import globalState from "globalState/globalState";

export function isValid(record) {
  const { connectedToQBO, automatedSalesTax, taxEnabled } =
    globalState.getState().userCompanySettings.settings;
  const errors = initialErrorState();
  if (!record.name || !record.name.length) {
    errors.messages.push(i18n("customer.LineItemError.Name"));
    errors.entity.push("name");
  }
  if (record.email && !isOneOrMoreEmailAddresses(record.email)) {
    errors.messages.push(i18n("customer.isValid.Email"));
    errors.entity.push("email");
  }
  if (record.website && !isSafeUrl(record.website)) {
    errors.messages.push(i18n("customer.isValid.Website"));
    errors.entity.push("website");
  }

  if (
    connectedToQBO &&
    automatedSalesTax &&
    taxEnabled &&
    !record.tax?.taxable &&
    !record.tax?.taxExemptReasonId
  ) {
    errors.messages.push(i18n("customer.isValid.taxExemptReasonId"));
    errors.entity.push("taxExemptReasonId");
  }

  return errors;
}
